var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-full flex justify-center" },
    [
      _c(
        "jade-page-container",
        { attrs: { size: "wide" } },
        [
          _vm.isLoading
            ? _c("onboarding-loading")
            : _c(
                "div",
                { staticClass: "w-full flex flex-col gap-6" },
                [
                  _vm.canShowKycFeedback ? _c("kyc-feedback") : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-full flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex sm:items-center gap-4 flex-col sm:flex-row",
                        },
                        [
                          _c("date-select", {
                            staticClass: "w-full lg:w-auto",
                            attrs: { "is-loading": _vm.isLoading },
                          }),
                          _c("report-button", {
                            staticClass: "w-full lg:w-auto",
                            attrs: { size: "medium", report: _vm.report },
                            on: { callback: _vm.printDashboard },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex sm:items-center gap-4 flex-col sm:flex-row",
                        },
                        [
                          !_vm.isBusinessGateway
                            ? _c(
                                "jade-button",
                                {
                                  staticClass: "w-full lg:w-auto",
                                  attrs: {
                                    icon: "percent-box",
                                    size: "medium",
                                    variant: "neutral-ghost",
                                  },
                                  on: { click: _vm.toggleDrawerFeesCalculator },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("simulator")) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.canShowShop
                            ? _c(
                                "jade-button",
                                {
                                  staticClass: "w-full lg:w-auto",
                                  attrs: {
                                    size: "medium",
                                    icon: "plus",
                                    variant: "primary-solid",
                                  },
                                  on: { click: _vm.openShop },
                                },
                                [_vm._v(_vm._s(_vm.$t("create-order")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "section",
                    {
                      ref: "dashboard",
                      staticClass: "w-full flex flex-col gap-6",
                    },
                    [
                      _c("charges", { attrs: { data: _vm.charges } }),
                      _c("transaction-status", {
                        attrs: { data: _vm.status, total: _vm.totalQuantity },
                      }),
                      _c(
                        "div",
                        { staticClass: "flex flex-col lg:flex-row gap-6" },
                        [
                          _c("payment-methods", {
                            attrs: { data: _vm.paymentMethods },
                          }),
                          _c("brands", { attrs: { data: _vm.brands } }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex flex-col lg:flex-row gap-6" },
                        [
                          _vm.isBusinessGateway
                            ? _c("acquirer", { attrs: { data: _vm.acquirers } })
                            : _vm._e(),
                          _c("refusal-codes", {
                            attrs: {
                              data: _vm.refusalCodes,
                              total: _vm.totalQuantity,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex flex-col lg:flex-row gap-6" },
                        [
                          _c("conversion", {
                            attrs: { data: _vm.paymentMethods },
                          }),
                          _c("installments", {
                            attrs: { data: _vm.installments },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }